module.exports = __webpack_public_path__ + "img/farming_32.c7b9e78d.png";